module.exports = require("isarray");


//////////////////
// WEBPACK FOOTER
// external "isarray"
// module id = 385
// module chunks = 0